import {
  DefaultEntityFilters,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

export class EntitySoxFilter implements EntityFilter {
  constructor(readonly values: string[]) {}
  filterEntity(entity: Entity): boolean {
    const sox = entity.metadata.labels?.['heroku.com/sox'];
    return sox !== undefined && this.values.includes(sox);
  }
}

export class EntitySoc2Filter implements EntityFilter {
  constructor(readonly values: string[]) {}
  filterEntity(entity: Entity): boolean {
    const soc2 = entity.metadata.labels?.['heroku.com/soc2'];
    return soc2 !== undefined && this.values.includes(soc2);
  }
}

export class EntityStackFilter implements EntityFilter {
  constructor(readonly values: string[]) {}
  filterEntity(entity: Entity): boolean {
    const stack = entity.metadata.labels?.['heroku.com/stack'];

    // Handle special case for missing stack
    if (this.values.includes('__missing__')) {
      const hasMissingStack =
        stack === undefined || stack === null || stack === '';
      if (hasMissingStack) return true;
    }

    const regularValues = this.values.filter(value => value !== '__missing__');
    return stack !== undefined && regularValues.includes(stack);
  }
}

export class EntityComponentTierFilter implements EntityFilter {
  constructor(readonly values: string[]) {}
  filterEntity(entity: Entity): boolean {
    const componentTier = entity.metadata.labels?.['heroku.com/component-tier'];

    // Handle special case for missing component tier
    if (this.values.includes('__missing__')) {
      const hasMissingTier =
        componentTier === undefined ||
        componentTier === null ||
        componentTier === '';
      if (hasMissingTier) return true;
    }

    // Handle regular tier values
    const regularValues = this.values.filter(value => value !== '__missing__');
    return componentTier !== undefined && regularValues.includes(componentTier);
  }
}

export type CustomFilters = DefaultEntityFilters & {
  sox?: EntitySoxFilter;
  soc2?: EntitySoc2Filter;
  componentTier?: EntityComponentTierFilter;
  stack?: EntityStackFilter;
};
